import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { buildWhatsAppLink } from "@/lib/whatsapp";
import { Logo } from "@/components/site/Logo";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: "Academy", href: isHome ? "#academy" : "/#academy" },
    { label: "Método MACD", href: isHome ? "#macd" : "/#macd" },
    { label: "Formações", href: isHome ? "#formacoes" : "/#formacoes" },
    { label: "Fundador", href: isHome ? "#gilson" : "/#gilson" },
    { label: "Insights", href: isHome ? "#insights" : "/#insights" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? "bg-white/95 backdrop-blur-md border-b border-[#e5e2db]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[72px] md:h-[88px] flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo"
          aria-label="Oasys Academy — Início"
          className="flex items-center group"
        >
          <Logo size="sm" priority className="rounded-[2px] shadow-[0_1px_0_rgba(0,0,0,0.04)]" />
        </Link>

        <nav
          className="hidden lg:flex items-center gap-9"
          data-testid="navbar-links"
        >
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] tracking-wide text-[#1f1f1f] hover:text-[#0a0a0a] relative group transition-colors"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 w-0 h-px bg-[#f2b705] group-hover:w-full transition-all duration-500" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={buildWhatsAppLink(
              "Olá! Quero conhecer as próximas turmas da Oasys Academy.",
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-cta-button"
            className="hidden md:inline-flex items-center text-[11px] tracking-[0.16em] uppercase font-semibold border-b border-[#0a0a0a] pb-1 hover:border-[#f2b705] hover:text-[#7a5a00] transition-colors"
          >
            Falar com a Academy
          </a>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            data-testid="navbar-mobile-toggle"
            aria-label="Abrir menu"
            className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-[5px]"
          >
            <span
              className={`block w-5 h-px bg-[#0a0a0a] transition-transform ${open ? "translate-y-[3px] rotate-45" : ""}`}
            />
            <span
              className={`block w-5 h-px bg-[#0a0a0a] transition-transform ${open ? "-translate-y-[3px] -rotate-45" : ""}`}
            />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden bg-white border-t border-[#e5e2db] transition-[max-height] duration-500 ${open ? "max-h-[600px]" : "max-h-0"}`}
        data-testid="navbar-mobile-menu"
      >
        <div className="px-6 py-8 flex flex-col gap-6">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="font-display text-2xl text-[#0a0a0a]"
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={buildWhatsAppLink(
              "Olá! Quero conhecer as próximas turmas da Oasys Academy.",
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="mobile-navbar-cta"
            className="btn-primary mt-4 w-fit"
          >
            Falar com a Academy
          </a>
        </div>
      </div>
    </header>
  );
};
